import { RequestMethods } from "../../constants";
export const getTokenRequestParameters = function (url, parser, body, requestProperties) {
    let data = { url, parser, options: {
            method: RequestMethods.GET,
            body,
            headers: {
                "Content-Type": "application/json"
            }
        } };
    Object.assign(data.options, requestProperties);
    return data;
};
//# sourceMappingURL=getTokenRequestParameters.js.map